import { Text, Table, TableContainer, Th, Thead, Tbody, Td, Tr, Flex, Box } from '@chakra-ui/react'
import { api } from '../../../../../../services/api'
import { useQuery } from 'react-query'
import { useState } from 'react'
import { Input } from '../../../../../../components/Form'
import { useDebounce } from '../../../../../../hooks/useDebounce'
import { user } from '../../../../../../helpers/user'
import { ItemContato } from './ItemContato'
import { Button } from '../../../../../../components/Button'

async function getListaContato({ search, codigo_vendedor }) {
  search = search.replace(/[^\w\s]/gi, '')

  const response = await api.get('/site/v2/orcamento-crm/busca-parceiro-orcamento', {
    params: {
      indice: search,
      codigo_vendedor,
    },
  })

  return response.data
}

export function ListContato({ parceiroSelecionado, setParceiroSelecionado, setValue }) {
  const [search, setSearch] = useState('')
  const debouncedSearch = useDebounce(search, 500)

  const { data: listaContato = [], isLoading } = useQuery({
    queryKey: ['listaContato', debouncedSearch],
    queryFn: () =>
      getListaContato({
        search: debouncedSearch,
        codigo_vendedor: user.codigo_vendedor,
      }),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 10,
    enabled: !!debouncedSearch,
  })

  function handleClienteSelecionado(cliente) {
    setValue('cpfCnpj', cliente.cnpj)
    setParceiroSelecionado(cliente)
  }

  console.log('parceiroSelecionado', parceiroSelecionado)

  return (
    <Box>
      <Flex
        as="form"
        onSubmit={(e) => {
          e.preventDefault()
          setSearch(e.target.nomeParceiro.value)
        }}
        alignItems="flex-end"
      >
        <Input label="Digite a razão social / Código do parceiro ou CNPJ" id="nomeParceiro" name="nomeParceiro" />
        <Button type="submit" size="sm" ml={2} isLoading={isLoading}>
          Buscar
        </Button>
      </Flex>
      <TableContainer overflowY="auto" w="100%" maxH="300px">
        <Table w="100%" borderCollapse="collapse">
          <Thead>
            <Tr>
              <Th>Código</Th>
              <Th>Cliente</Th>
              <Th>CNPJ</Th>
              <Th />
            </Tr>
          </Thead>
          <Tbody>
            {!isLoading && listaContato.length === 0 && (
              <Tr>
                <Td colSpan="4" textAlign="center">
                  <Text>Nenhum registro encontrado</Text>
                </Td>
              </Tr>
            )}
            {isLoading && (
              <Tr>
                <Td colSpan="4" textAlign="center">
                  <Text>Carregando...</Text>
                </Td>
              </Tr>
            )}

            {listaContato.map((item, index) => (
              <ItemContato
                key={index}
                item={item}
                isSelected={parceiroSelecionado === item.cliente}
                onSelect={() => handleClienteSelecionado(item.cliente)}
              />
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  )
}
